// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AckoDriveStepsClientWrapper_wrapper__XpFQ7","shimmer":"AckoDriveStepsClientWrapper_shimmer__y4QNY"};